import React from "react";
import { DA_Title, DA_TitleTypeface } from "../../atoms/Title/Title.component";
import { DA_Text } from "../../atoms/Text/Text.component";
import S from "./DynamicContent.module.scss";

interface BaseProps {
    title: React.ReactNode;
    text?: React.ReactNode;
    largeTitle?: boolean;
}

interface ContentProps {
    content?: React.ReactNode;
    children?: never;
}

interface ChildrenProps {
    content?: never;
    children?: React.ReactNode;
}

export type DA_DynamicContentProps = BaseProps & (ContentProps | ChildrenProps);

export const DA_DynamicContent = ({
    title,
    text,
    largeTitle,
    content,
    children,
}: DA_DynamicContentProps) => (
    <div className={S.wrapper}>
        <div className={S.col1}>
            <DA_Title typeface={largeTitle ? DA_TitleTypeface.H1 : DA_TitleTypeface.H3}>
                {title}
            </DA_Title>
            {text && <DA_Text>{text}</DA_Text>}
        </div>

        {(content || children) && <div className={S.col2}>{content || children}</div>}
    </div>
);
